import React, { useState } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Icon,
  Input,
  Button,
} from "@chakra-ui/react";
import { FiAtSign } from "react-icons/fi";

const CheckmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.67 10.67L4.83 8.83L4.125 9.54L6.67 12.085L12.67 6.085L11.96 5.375L6.67 10.67Z"
      fill="#389D1B"
    />
  </svg>
);

export const TrainersToolkit = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    if (!email.trim() || !validateEmail(email)) {
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("formType", "trainer_toolkit");
      formData.append("email", email.trim());

      await fetch(process.env.REACT_APP_GOOGLE_APPS_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      // Since we're using no-cors mode, we can't read the response
      // but Google Apps Script will process the data successfully
      setEmail("");
      setIsSubmitted(true);
      onSuccess?.();
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      bg="white"
      borderRadius="12px"
      boxShadow="0px 2px 4px rgba(12, 0, 28, 0.04), 0px 0px 6px rgba(12, 0, 28, 0.02)"
      p={3}
    >
      <VStack spacing={4} align="stretch">
        <Text
          fontSize="12px"
          fontWeight="84"
          lineHeight="1.5"
          letterSpacing="-1%"
          color="#000000"
          fontFamily="Geist, sans-serif"
        >
          🎓 Trainer's Toolkit coming soon! Sign up for early access!
        </Text>

        <HStack
          borderRadius="12px"
          border="1px solid #D0CCD5"
          bg="white"
          px={3}
          py={2}
          h="43px"
        >
          <Icon as={FiAtSign} w="20px" h="20px" color="#B8B2C0" />
          <Input
            placeholder="pete@email.com"
            fontSize="14px"
            fontWeight="400"
            lineHeight="1.429"
            letterSpacing="-2%"
            color="#433358"
            fontFamily="Geist, sans-serif"
            border="none"
            _focus={{ boxShadow: "none" }}
            p={0}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter" && !isLoading) {
                handleSubmit();
              }
            }}
          />
        </HStack>

        <Button
          bg="#4C47CC"
          color="white"
          fontSize="13px"
          fontWeight="700"
          lineHeight="1.231"
          fontFamily="Geist, sans-serif"
          borderRadius="8px"
          px="8px"
          py="8px"
          h="auto"
          minH="auto"
          w="fit-content"
          transition="all 0.2s"
          isLoading={isLoading}
          loadingText="Submitting..."
          isDisabled={!email.trim() || isLoading || isSubmitted}
          _hover={{
            bg: "#3A37B3",
            transform: !isLoading ? "translateY(-1px)" : "none",
          }}
          _active={{
            transform: "translateY(0px)",
          }}
          _disabled={{
            bg: "#B8B2C0",
            cursor: "not-allowed",
            transform: "none",
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>

        {/* {isSubmitted && (
          <Box
            bg="rgba(56, 157, 27, 0.17)"
            borderRadius="8px"
            p={2}
            alignSelf="stretch"
          >
            <HStack spacing={2} justify="center">
              <CheckmarkIcon />
              <Text
                fontSize="13px"
                fontWeight="700"
                lineHeight="1.231"
                fontFamily="Geist, sans-serif"
                color="#389D1B"
              >
                Thank you, we received your message
              </Text>
            </HStack>
          </Box>
        )} */}
      </VStack>
    </Box>
  );
};
